// Static league definitions used by the Leagues nav dropdown + placeholder
// league hubs. These are lightweight "templates" — a future phase will make each
// league fully customisable (logo/colour/teams) from Admin, mirroring PWHL teams.
// A league is either a flat `teams` list OR grouped `conferences`.
export const LEAGUES = {
    usports: {
        id: "usports",
        name: "USports",
        full: "U Sports Women's Ice Hockey",
        category: "College · Canada",
        color: "#C8102E",
        conferences: [
            {
                name: "Canada West",
                teams: [
                    "Alberta Pandas", "UBC Thunderbirds", "Calgary Dinos", "Manitoba Bisons",
                    "Mount Royal Cougars", "Regina Cougars", "Saskatchewan Huskies", "MacEwan Griffins",
                ],
            },
            {
                name: "OUA (Ontario)",
                teams: [
                    "Toronto Varsity Blues", "TMU Bold", "Queen's Gaels", "Western Mustangs",
                    "Waterloo Warriors", "Laurier Golden Hawks", "Guelph Gryphons", "Brock Badgers",
                    "York Lions", "Ontario Tech Ridgebacks", "Nipissing Lakers", "Windsor Lancers",
                    "Carleton Ravens", "Ottawa Gee-Gees", "McGill Martlets",
                ],
            },
            {
                name: "RSEQ (Quebec)",
                teams: ["Concordia Stingers", "Montréal Carabins", "Bishop's Gaiters"],
            },
            {
                name: "AUS (Atlantic)",
                teams: [
                    "St. Francis Xavier X-Women", "UNB Reds", "St. Thomas Tommies", "UPEI Panthers",
                    "Saint Mary's Huskies", "Mount Allison Mounties", "Acadia Axewomen", "Dalhousie Tigers",
                ],
            },
        ],
    },
    sdhl: {
        id: "sdhl",
        name: "SDHL",
        full: "Svenska Damhockeyligan",
        category: "Club · Sweden",
        color: "#F5C518",
        teams: [
            "Brynäs IF", "Djurgårdens IF", "Frölunda HC", "Färjestad BK", "HV71",
            "Linköping HC", "Luleå Hockey", "MoDo Hockey", "SDE HF", "Skellefteå AIK",
        ],
    },
    auroraliiga: {
        id: "auroraliiga",
        name: "Auroraliiga",
        full: "Auroraliiga (W)",
        category: "Club · Finland",
        color: "#3DBE78",
        teams: [
            "Kärpät", "Team Kuortane", "Ilves", "TPS", "HPK", "Pelicans", "Kiekko-Espoo", "HIFK",
        ],
    },
    zhhl: {
        id: "zhhl",
        name: "ZhHL",
        full: "Zhenskaya Hockey League (Russia)",
        category: "Club · Russia",
        color: "#D52B1E",
        teams: [
            "Agidel Ufa", "Biryusa Krasnoyarsk", "Dynamo-Neva St. Petersburg", "SKIF Nizhny Novgorod",
            "Tornado Moscow Region", "Torpedo Nizhny Novgorod", "Sakhalin", "7.62 Voskresensk",
            "Belye Medveditsy Chelyabinsk",
        ],
    },
    swhl: {
        id: "swhl",
        name: "SWHL",
        full: "Swiss Women's Hockey League (PostFinance Women's League)",
        category: "Club · Switzerland",
        color: "#D80027",
        teams: [
            "SC Bern Frauen", "EVZ Women's Team", "HC Davos Ladies", "HC Ambrì-Piotta Women",
            "ZSC Lions Frauen", "HC Fribourg-Gottéron Ladies", "Lausanne HC Féminin",
            "Neuchâtel Hockey Academy Dames",
        ],
    },
    dfel: {
        id: "dfel",
        name: "DFEL",
        full: "Deutsche Frauen-Eishockey-Liga (Germany)",
        category: "Club · Germany",
        color: "#E2B007",
        teams: [
            "ECDC Memmingen Indians", "Eisbären Juniors Berlin", "ERC Ingolstadt",
            "HK Budapest (Hokiklub Budapest)", "Mad Dogs Mannheim",
        ],
    },
    ewhl: {
        id: "ewhl",
        name: "EWHL",
        full: "European Women's Hockey League",
        category: "Club · Europe",
        color: "#0057B7",
        teams: [
            "Aisulu Almaty", "EVB Eagles South Tyrol", "HK PSRZ Bratislava", "Sabres St. Pölten",
            "Lakers Kärnten", "Bolzano Eagles", "MAC Budapest", "Team Croatia Select",
            "KSV Neuberg Highlanders",
        ],
    },
    ccwha: {
        id: "ccwha",
        name: "CCWHA",
        full: "Central Collegiate Women's Hockey Association",
        category: "College · USA",
        color: "#1D4ED8",
        teams: [
            "Adrian College", "Assiniboine College", "Davenport University", "Grand Valley State University",
            "Liberty University", "Michigan State University", "University of Michigan", "Western Michigan University",
        ],
    },
    ncaad3: {
        id: "ncaad3",
        name: "NCAA DIII",
        full: "NCAA Division III Women's Hockey",
        category: "College · USA",
        color: "#2563EB",
        teams: [
            "Adrian", "Amherst", "Augsburg", "Bowdoin", "Castleton", "Chatham", "Colby", "Concordia (MN)",
            "Elmira", "Endicott", "Gustavus Adolphus", "Hamilton", "Middlebury", "Nazareth", "Norwich",
            "Plattsburgh State", "St. Norbert", "St. Olaf", "St. Scholastica", "UW-Eau Claire",
            "UW-River Falls", "UW-Stevens Point", "UW-Superior", "Williams", "Wilkes", "Wesleyan", "Utica",
            "Trinity", "Saint Anselm", "Rivier", "Plymouth State", "Oswego State", "Morrisville State",
            "Manhattanville", "Johnson & Wales", "Franklin Pierce", "SUNY Cortland", "Buffalo State",
            "SUNY Canton", "Suffolk", "Salem State", "Sacred Heart", "King's College", "Lebanon Valley",
            "Nichols", "Post University", "Stevenson", "William Smith", "Worcester State", "University of New England",
        ],
    },
    olympics: {
        id: "olympics",
        name: "Olympics",
        full: "Olympic Women's Ice Hockey",
        category: "International",
        color: "#1A6BB0",
        teams: [
            "Canada", "United States", "Finland", "Switzerland", "Sweden", "Czechia",
            "Japan", "Germany", "Hungary", "China", "Norway", "Denmark", "Russia",
        ],
    },
    iihf: {
        id: "iihf",
        name: "IIHF",
        full: "IIHF Women's World Championship",
        category: "International",
        color: "#0A3D7A",
        teams: [
            "Canada", "United States", "Finland", "Switzerland", "Sweden", "Czechia",
            "Japan", "Germany", "Hungary", "France", "Norway", "Denmark", "Italy", "Slovakia", "Russia",
        ],
    },
};

export const LEAGUE_IDS = Object.keys(LEAGUES);
